import { jsx as _jsx } from "react/jsx-runtime";
var BirreteApps = function BirreteApps(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "m21.497 6.36-8.112-3.765a2.054 2.054 0 0 0-1.752 0l-8.1 3.765a1.957 1.957 0 0 0-.824.695c-.2.3-.305.647-.304 1.001a1.62 1.62 0 0 0 0 .238v5.744c0 .225.095.44.263.6.17.159.398.248.637.248.238 0 .467-.09.636-.249a.824.824 0 0 0 .264-.6v-4.024l.924.43v7.778a.83.83 0 0 0 .3.577l.156.136c1.85 1.709 4.338 2.666 6.93 2.666 2.591 0 5.08-.957 6.93-2.666l.144-.136a.824.824 0 0 0 .264-.6v-7.756l1.632-.69c.34-.152.626-.393.826-.693a1.808 1.808 0 0 0 .001-2c-.197-.3-.48-.542-.815-.699Zm-3.444 11.51c-1.505 1.324-3.486 2.06-5.544 2.06-2.058 0-4.04-.736-5.544-2.06v-6.614l4.68 2.115a2.03 2.03 0 0 0 1.728 0l4.68-2.115v6.615Zm2.652-9.7-8.112 3.674a.215.215 0 0 1-.168 0L4.313 8.17a.2.2 0 0 1-.08-.071.184.184 0 0 1 0-.198.2.2 0 0 1 .08-.07l8.112-3.732h.168l8.112 3.731c.032.017.06.041.079.071a.184.184 0 0 1 0 .198.199.199 0 0 1-.08.07Z",
      fill: color
    })
  });
};
export default BirreteApps;